import { render, staticRenderFns } from "./DataAvailability.vue?vue&type=template&id=2fc7be9c&scoped=true&"
import script from "./DataAvailability.vue?vue&type=script&lang=ts&"
export * from "./DataAvailability.vue?vue&type=script&lang=ts&"
import style0 from "./DataAvailability.vue?vue&type=style&index=0&id=2fc7be9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc7be9c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VSkeletonLoader,VTextField})
